import { useEffect, useState } from 'react';
import API from '../api';

const empty = { icon:'🧹', title:'', description:'', priceFrom:'', priceUnit:'сум', featured:false, active:true };
const inp = (extra={}) => ({ width:'100%', padding:'10px 13px', border:'1.5px solid #E5E7EB', borderRadius:9, fontSize:'0.875rem', outline:'none', background:'#FAFAFA', boxSizing:'border-box', fontFamily:"'Golos Text',sans-serif", ...extra });
const lbl = { display:'block', fontSize:'0.75rem', fontWeight:700, color:'#6B7280', marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' };

function Toast({ msg, type, onDone }) {
  useEffect(()=>{ const t=setTimeout(onDone,2800); return()=>clearTimeout(t); },[onDone]);
  const c = type==='success' ? { bg:'#F0FDF4',color:'#166534',border:'#BBF7D0' } : { bg:'#FEF2F2',color:'#991B1B',border:'#FECACA' };
  return <div style={{ position:'fixed',bottom:24,right:24,zIndex:9999,background:c.bg,color:c.color,border:`1px solid ${c.border}`,padding:'12px 20px',borderRadius:12,fontWeight:600,fontSize:'0.875rem',boxShadow:'0 4px 20px rgba(0,0,0,.1)' }}>{msg}</div>;
}

function Modal({ svc, onClose, onSave }) {
  const [form, setForm] = useState({...svc});
  const set = (k,v) => setForm(p=>({...p,[k]:v}));
  return (
    <div style={{ position:'fixed',inset:0,background:'rgba(0,0,0,.4)',zIndex:999,display:'grid',placeItems:'center',padding:24 }} onClick={onClose}>
      <div style={{ background:'#fff',borderRadius:18,padding:'28px',width:'100%',maxWidth:520,maxHeight:'90vh',overflowY:'auto',boxShadow:'0 20px 60px rgba(0,0,0,.15)' }} onClick={e=>e.stopPropagation()}>
        <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:22 }}>
          <h2 style={{ fontFamily:"'Unbounded',sans-serif",fontWeight:800,fontSize:'1.1rem',margin:0 }}>{svc.id?'Редактировать':'Новая услуга'}</h2>
          <button onClick={onClose} style={{ background:'#F5F5F5',border:'none',borderRadius:8,width:30,height:30,cursor:'pointer',fontSize:'1rem',display:'grid',placeItems:'center' }}>✕</button>
        </div>
        <div style={{ display:'grid',gridTemplateColumns:'70px 1fr',gap:12,marginBottom:12 }}>
          <div><label style={lbl}>Иконка</label><input value={form.icon} onChange={e=>set('icon',e.target.value)} style={inp({textAlign:'center',fontSize:'1.4rem'})} maxLength={4}/></div>
          <div><label style={lbl}>Название</label><input value={form.title} onChange={e=>set('title',e.target.value)} placeholder="Название услуги" style={inp()}/></div>
        </div>
        <div style={{ marginBottom:12 }}>
          <label style={lbl}>Описание</label>
          <textarea value={form.description} onChange={e=>set('description',e.target.value)} rows={3} placeholder="Описание..." style={{ ...inp(),resize:'vertical',lineHeight:1.6 }}/>
        </div>
        <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:12 }}>
          <div><label style={lbl}>Цена от</label><input type="number" value={form.priceFrom||''} onChange={e=>set('priceFrom',e.target.value)} placeholder="79000" style={inp()}/></div>
          <div><label style={lbl}>Единица</label><input value={form.priceUnit} onChange={e=>set('priceUnit',e.target.value)} placeholder="сум" style={inp()}/></div>
        </div>
        <div style={{ display:'flex',gap:20,marginBottom:22 }}>
          {[['featured','⭐ Рекомендуемая'],['active','✅ Активная']].map(([k,l])=>(
            <label key={k} style={{ display:'flex',alignItems:'center',gap:8,cursor:'pointer',fontSize:'0.875rem',fontWeight:600,color:'#374151' }}>
              <input type="checkbox" checked={form[k]} onChange={e=>set(k,e.target.checked)} style={{ width:16,height:16,accentColor:'#00C2B8' }}/>{l}
            </label>
          ))}
        </div>
        <div style={{ display:'flex',gap:10 }}>
          <button onClick={()=>onSave(form)} style={{ flex:1,padding:'12px',background:'#00C2B8',color:'#06101e',border:'none',borderRadius:10,fontFamily:"'Unbounded',sans-serif",fontWeight:700,fontSize:'0.85rem',cursor:'pointer' }}>Сохранить</button>
          <button onClick={onClose} style={{ padding:'12px 20px',background:'#F5F5F5',color:'#6B7280',border:'none',borderRadius:10,fontWeight:700,fontSize:'0.85rem',cursor:'pointer' }}>Отмена</button>
        </div>
      </div>
    </div>
  );
}

export default function AdminServices() {
  const [services, setServices] = useState([]);
  const [modal, setModal]       = useState(null);
  const [toast, setToast]       = useState(null);

  const load = () => API.get('/admin/services').then(r=>setServices(r.data)).catch(()=>{});
  useEffect(()=>{ load(); },[]);

  const save = async form => {
    try {
      if (form.id) await API.put(`/admin/services/${form.id}`,form);
      else await API.post('/admin/services',form);
      load(); setModal(null); setToast({ msg:'✓ Сохранено',type:'success' });
    } catch { setToast({ msg:'Ошибка',type:'error' }); }
  };
  const del = async id => {
    if (!window.confirm('Удалить?')) return;
    await API.delete(`/admin/services/${id}`); load(); setToast({ msg:'Удалено',type:'success' });
  };
  const toggle = async (svc) => {
    await API.put(`/admin/services/${svc.id}`,{...svc,active:!svc.active}); load();
  };

  return (
    <div>
      {toast && <Toast msg={toast.msg} type={toast.type} onDone={()=>setToast(null)}/>}
      {modal && <Modal svc={modal} onClose={()=>setModal(null)} onSave={save}/>}

      <div style={{ display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:24 }}>
        <div>
          <h1 style={{ fontFamily:"'Unbounded',sans-serif",fontWeight:800,fontSize:'1.4rem',color:'#06101e',margin:'0 0 4px' }}>Услуги</h1>
          <p style={{ color:'#9CA3AF',fontSize:'0.875rem',margin:0 }}>{services.filter(s=>s.active).length} активных из {services.length}</p>
        </div>
        <button onClick={()=>setModal({...empty})} style={{ padding:'10px 18px',background:'#00C2B8',color:'#06101e',border:'none',borderRadius:10,fontFamily:"'Unbounded',sans-serif",fontWeight:700,fontSize:'0.8rem',cursor:'pointer',boxShadow:'0 4px 14px rgba(0,194,184,.3)' }}>+ Добавить</button>
      </div>

      <div style={{ display:'grid',gap:10 }}>
        {services.map(s => (
          <div key={s.id} style={{ background:'#fff',borderRadius:14,padding:'16px 20px',boxShadow:'0 1px 8px rgba(0,0,0,.05)',border:'1px solid #F0F0F0',display:'flex',alignItems:'center',gap:16,opacity:s.active?1:0.55 }}>
            <div style={{ width:44,height:44,borderRadius:12,background:'#F5F7FA',display:'grid',placeItems:'center',fontSize:'1.5rem',flexShrink:0 }}>{s.icon}</div>
            <div style={{ flex:1,minWidth:0 }}>
              <div style={{ display:'flex',alignItems:'center',gap:8,marginBottom:3 }}>
                <span style={{ fontWeight:700,fontSize:'0.9rem',color:'#111' }}>{s.title}</span>
                {s.featured && <span style={{ background:'#FEF3C7',color:'#92400E',fontSize:'0.65rem',fontWeight:700,padding:'2px 7px',borderRadius:20 }}>Рекомендуем</span>}
                {!s.active && <span style={{ background:'#F5F5F5',color:'#9CA3AF',fontSize:'0.65rem',fontWeight:700,padding:'2px 7px',borderRadius:20 }}>Неактивна</span>}
              </div>
              <div style={{ color:'#9CA3AF',fontSize:'0.8rem',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap' }}>{s.description}</div>
            </div>
            {s.priceFrom && <div style={{ fontFamily:"'Unbounded',sans-serif",fontWeight:800,fontSize:'0.85rem',color:'#00C2B8',whiteSpace:'nowrap',flexShrink:0 }}>{Number(s.priceFrom).toLocaleString()} {s.priceUnit}</div>}
            <div style={{ display:'flex',gap:8,flexShrink:0 }}>
              <button onClick={()=>toggle(s)} style={{ padding:'6px 12px',background:s.active?'#F0FDF4':'#F9FAFB',color:s.active?'#16A34A':'#9CA3AF',border:'none',borderRadius:8,fontWeight:700,fontSize:'0.75rem',cursor:'pointer' }}>{s.active?'Вкл':'Выкл'}</button>
              <button onClick={()=>setModal({...s})} style={{ padding:'6px 12px',background:'rgba(0,194,184,.08)',color:'#00C2B8',border:'none',borderRadius:8,fontWeight:700,fontSize:'0.75rem',cursor:'pointer' }}>Изменить</button>
              <button onClick={()=>del(s.id)} style={{ padding:'6px 9px',background:'#FEF2F2',color:'#EF4444',border:'none',borderRadius:8,fontWeight:700,fontSize:'0.75rem',cursor:'pointer' }}>✕</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
